import * as React from 'react';
import { CircledCheckmark } from '../../common';
import { ReportType } from '../../../enums';
import { BaseRouteProps } from '../../../interfaces';
import { FilterStore, UserStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import './InteractionReport.css';

interface InteractionReportBlockState {
    reportType: ReportType;
}

interface InteractionReportBlockProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
    UserStore?: UserStore;
}

@inject('FilterStore', 'UserStore') @observer
export class InteractionReportBlock extends React.Component<InteractionReportBlockProps, InteractionReportBlockState> {
    constructor(props: InteractionReportBlockProps) {
        super(props);

        this.state = {
            reportType: ReportType.Standard,
        };
    }

    @computed get userId() {
        if (this.props.FilterStore && this.props.FilterStore.interactionReportUserId) {
            return this.props.FilterStore.interactionReportUserId;
        }
        return this.props.UserStore!.userInfo.id;
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    @computed get userPermissions() {
        return this.props.UserStore!.userInfo.userPermissions;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    @computed get selectedUserData() {
        return this.props.FilterStore!.interactionReportUserData;
    }

    public render() {
        const selectedUserData = this.selectedUserData;
        if (!selectedUserData || !selectedUserData.groups || selectedUserData.groups.length === 0) {
            return null;
        }

        return <>
                {selectedUserData.groups.filter((x: any) => {
                    if (!this.surveyReportType) {
                        return true;
                    }
                    return x.surveyReportTypeID === this.surveyReportType.id;
                }).map((dataGroup: any, dataGroupInd: number) => {
                    return <React.Fragment key={dataGroupInd}>
                        {
                            dataGroup.data.map((entry: any, entryInd: number) => {
                                const styleClass = this.selectedUserData.style && this.selectedUserData.style.name ? `style-${this.selectedUserData.style.name.toLowerCase()}` : '';
                                return <div key={entryInd} className={`interaction-block`}>
                                    <div className="group-title font-second-level">{entry.displayName ? entry.displayName : entry.name}</div>
                                    <div className={`interaction-info ${styleClass}`}>
                                        <div className="text help-text">
                                            <div className="heading font-subheading">
                                                <CircledCheckmark />
                                                <span>What helps an individual</span>
                                            </div>
                                            <div className="custom-content" dangerouslySetInnerHTML={{ __html: entry.helpText }} />
                                        </div>
                                        <div className="text hurt-text">
                                            <div className="heading font-subheading">
                                                <img src="/images/close x.svg" />
                                                <span>What hurts an individual</span>
                                            </div>
                                            <div className="custom-content" dangerouslySetInnerHTML={{ __html: entry.hurtText }} />
                                        </div>
                                    </div>
                                </div>;
                            })
                        }
                    </React.Fragment>;
                })}
            </>;
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/interaction/InteractionReportBlock.tsx